import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CTASection() {
  return <section className="bg-au-green text-white py-20" data-id="element-97">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-99">
          <h2 className="text-4xl font-serif mb-4" data-id="element-100">
            Ready to Partner with Us?
          </h2>
          <div className="w-24 h-1 bg-au-gold mx-auto mb-6" data-id="element-101"></div>
          <p className="text-xl text-au-green-light mb-8" data-id="element-102">
            Join us in building sustainable partnerships that drive development
            and prosperity across Africa.
          </p>
          <div className="flex flex-wrap gap-4 justify-center" data-id="element-103">
            <Link to="/procurement/supplier-registration" data-id="element-104">
              <Button variant="secondary" className="bg-white flex items-center gap-2" data-id="element-105">
                Submit Expression of Interest
                <ArrowRightIcon size={20} data-id="element-106" />
              </Button>
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium border-2 border-white text-white bg-transparent hover:bg-white hover:text-au-green transition-colors duration-300" data-id="element-107">
              Contact Us
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}